/* OLW Fitness: mobile add-to-cart bar for product pages. */
(function () {
  'use strict';

  function initStickyCart() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      if (section.dataset.olwStickyCartReady === 'true') return;

      var source = section.querySelector('.ProductForm__AddToCart');
      if (!source) return;
      section.dataset.olwStickyCartReady = 'true';

      var bar = document.createElement('div');
      bar.className = 'OlwStickyCart';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'OlwStickyCart__Button Button Button--primary';
      bar.appendChild(button);
      document.body.appendChild(bar);

      function syncButton() {
        var label = source.querySelector('span');
        button.textContent = (label || source).textContent.trim();
        button.disabled = source.disabled;
      }

      function syncVisibility() {
        var sourceRect = source.getBoundingClientRect();
        var sectionRect = section.getBoundingClientRect();
        var drawerOpen = document.querySelector('.Drawer[aria-hidden="false"], .Modal[aria-hidden="false"]');
        bar.classList.toggle('is-visible',
          sourceRect.bottom < 0 && sectionRect.bottom > 0 && !drawerOpen);
      }

      button.addEventListener('click', function () {
        bar.classList.remove('is-visible');
        source.click();
      });

      new MutationObserver(syncButton).observe(source, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });

      window.addEventListener('scroll', syncVisibility, { passive: true });
      window.addEventListener('resize', syncVisibility);
      document.addEventListener('variant:changed', function () {
        syncButton();
        syncVisibility();
      });
      syncButton();
      syncVisibility();
    });
  }

  var style = document.createElement('style');
  style.textContent = '.OlwStickyCart { display: none; } @media (max-width: 1007px) {' +
    '.OlwStickyCart { position: fixed; z-index: 30; left: 0; right: 0; bottom: 0; ' +
    'display: none; padding: 12px 16px calc(12px + env(safe-area-inset-bottom)); ' +
    'background: #fff; border-top: 1px solid #dedede; box-shadow: 0 -4px 20px rgba(0,0,0,.08); }' +
    '.OlwStickyCart.is-visible { display: block; }' +
    '.OlwStickyCart__Button { width: 100%; min-height: 48px; }' +
    '}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
  document.addEventListener('shopify:section:load', initStickyCart);
})();

/* Navegação horizontal da galeria da comunidade OLW. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-olw-community-scroll]');
    if (!button) return;
    var section = button.closest('.OlwCommunity');
    var rail = section && section.querySelector('.OlwCommunity__Rail');
    if (!rail) return;
    var card = rail.querySelector('.OlwCommunity__Card');
    var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
    var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    rail.scrollBy({ left: distance * Number(button.dataset.olwCommunityScroll), behavior: 'smooth' });
  });
})();

/* OLW: controlled community rails and Shopify-hosted video playback. */
(function () {
  'use strict';

  function initSocialStories() {
    document.querySelectorAll('[data-section-type="olw-social-stories"]').forEach(function (section) {
      if (section.dataset.olwSocialReady === 'true') return;
      section.dataset.olwSocialReady = 'true';

      var rail = section.querySelector('.OlwSocial__Rail');
      var fill = section.querySelector('.OlwSocial__ProgressFill');
      if (!rail) return;

      function updateProgress() {
        if (!fill) return;
        var total = rail.scrollWidth || 1;
        var seen = Math.min(total, rail.scrollLeft + rail.clientWidth);
        fill.style.width = Math.max(12, Math.round(seen / total * 100)) + '%';
      }

      function step(direction) {
        var card = rail.querySelector('.OlwSocial__Card');
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      var dragStartX = 0;
      var dragStartScroll = 0;
      var dragging = false;
      var moved = false;

      rail.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('video, button, a')) return;
        dragStartX = event.clientX;
        dragStartScroll = rail.scrollLeft;
        dragging = true;
        moved = false;
      });
      rail.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var delta = event.clientX - dragStartX;
        if (!moved && Math.abs(delta) < 5) return;
        if (!moved) {
          moved = true;
          rail.classList.add('is-dragging');
        }
        rail.scrollLeft = dragStartScroll - delta;
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (moved) window.setTimeout(function () { moved = false; }, 0);
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('pointerleave', endDrag);
      rail.addEventListener('dragstart', function (event) { event.preventDefault(); });
      rail.addEventListener('click', function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      section.addEventListener('click', function (event) {
        var arrow = event.target.closest('[data-olw-social-scroll]');
        if (arrow) {
          step(Number(arrow.dataset.olwSocialScroll));
          return;
        }

        var play = event.target.closest('[data-olw-social-play]');
        if (!play) return;
        var card = play.closest('.OlwSocial__Card');
        var video = card && card.querySelector('video');
        if (!video) return;

        if (video.paused) {
          section.querySelectorAll('video').forEach(function (other) {
            if (other !== video) other.pause();
          });
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      section.querySelectorAll('video').forEach(function (video) {
        function syncPlayback() {
          var card = video.closest('.OlwSocial__Card');
          var button = card && card.querySelector('[data-olw-social-play]');
          if (!card || !button) return;
          var playing = !video.paused && !video.ended;
          card.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? 'Pausar vídeo' : 'Reproduzir vídeo');
          button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
        }
        video.addEventListener('play', syncPlayback);
        video.addEventListener('pause', syncPlayback);
        video.addEventListener('ended', syncPlayback);
      });

      rail.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (section.dataset.olwSocialAuto === 'true' && !reduceMotion) {
        var timer = window.setInterval(function () {
          if (!document.documentElement.contains(section)) {
            window.clearInterval(timer);
            return;
          }
          if (document.hidden || section.matches(':hover') || section.contains(document.activeElement)) return;
          if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3) {
            rail.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            step(1);
          }
        }, 3500);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSocialStories);
  } else {
    initSocialStories();
  }
  document.addEventListener('shopify:section:load', initSocialStories);
})();
